import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CityListComponent } from './city-list/city-list.component';
import { CityDetailsComponent } from './city-details/city-details.component';
import { AreaDetailsComponent } from './area-details/area-details.component';
import { AddCityComponent } from './add-city/add-city.component';
import { DistrictComponent } from './district/district.component';
import { SubdivisionComponent } from './subdivision/subdivision.component';
import { VillageComponent } from './village/village.component';


const routes: Routes = [
  { path: '', component: CityListComponent },
  { path: 'city-list', component: CityListComponent },
  { path: 'city-details', component: CityDetailsComponent },
  { path: 'area-details', component: AreaDetailsComponent },
  { path: 'add-city/:id', component: AddCityComponent },
  { path: 'district-list', component: DistrictComponent },  
  { path: 'subdivision/:id', component: SubdivisionComponent },
  { path: 'village/:id', component: VillageComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CityRoutingModule { }
